
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'
import ChangedateofinstallmentRepository from '@/shared/http/repositories/realestate/changedateofinstallment'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'PanelSales',
  mixins: [ActionsForm],
  props: ['selectedComissao'],

  data () {
    return {
      datapagamento: '',
      statusColor: {
        backgroundColor: ''
      },
      consultacomissao: [],
      foto: ''
    }
  },
  mounted () {
    this.getLogo()
    this.statusColor.backgroundColor = ['#30a75f', '#db3939', '#f6b535'][this.selectedComissao.status]
    this.statusText = ['Quitado', 'Atrasado', 'Em Andamento'][this.selectedComissao.status]
    this.getDataPagamento()
  },
  methods: {
    getLogo () {
      loading.push()
      FileEnterpriseRepository.GetLogoByEmpreendimentoId(this.selectedComissao.empreendimentoId)
        .then(Response => {
          loading.pop()
          this.foto = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getDataPagamento () {
      loading.push()
      ChangedateofinstallmentRepository.getDataPagamento(this.selectedComissao.empreendimentoUnidade.id)
        .then(Response => {
          loading.pop()
          this.datapagamento = Response.data.data
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/panelsales/panelsales.js